import { findUserByEmail, findGIDByUsername } from "../api/users";

const useSearchUser = (
  setActiveStep,
  setDiv2Visible,
  setDiv2FetchStatus,
  setDiv2Title,
  setUserInfo,
  setDiv2Error
) => {
  const searchUser = async (enteredUsername, usernameType = "email") => {
    console.log(
      `useSearchUser: searchUser: enteredUsername= ${enteredUsername}, usernameType= ${usernameType}`
    );
    setActiveStep(2);
    setDiv2Visible(true);
    setDiv2FetchStatus("searching");
    setDiv2Title("Searching for the user...");

    var { errorMsg, userInfo } = { errorMsg: "", userInfo: null };

    if (usernameType === "email") {
      ({ errorMsg, userInfo } = await findUserByEmail(enteredUsername));
    } else if (usernameType === "retailGID") {
      ({ errorMsg, userInfo } = await findGIDByUsername(enteredUsername));
    } else {
      console.error(
        `useSearchUser: searchUser: *** Unexpected usernameType: ${usernameType}`
      );
      setDiv2FetchStatus("error");
      setDiv2Title("Error!");
      setUserInfo(null);
      setDiv2Error(`Unexpected usernameType: ${usernameType}`);
      return;
    }

    if (userInfo) {
      setDiv2FetchStatus("data");
      setDiv2Title("");
      setUserInfo(userInfo);
      setDiv2Error("");
    } else if (errorMsg) {
      setDiv2FetchStatus("error");
      setDiv2Title("Error!");
      setUserInfo(null);
      setDiv2Error(errorMsg);
    } else {
      console.log(
        "useSearchUser:searchUser: *** Unexpected! No data or error message from findUserByEmail()"
      );
    }
  };

  return { searchUser };
};

export default useSearchUser;
